// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"noData__wrapper__3Mc","text":"noData__text__3wL","bounceIn":"noData__bounceIn__16-","highlightWallMessage":"noData__highlightWallMessage__3i0"};